import { FunctionComponent, PropsWithChildren } from "react";

import { FilterBar, Item } from "@bps/fluent-ui";

export interface SelectSoftwarePackageVersionFilterValues {
  name: string;
}

export const SelectSoftwarePackageVersionFilter: FunctionComponent<PropsWithChildren<
  any
>> = ({ children }) => {
  const filterItems: Item<SelectSoftwarePackageVersionFilterValues>[] = [
    {
      name: "name",
      type: "searchBox",
      stickItem: true,
      props: { placeholder: "Search by name", removeSpecialCharacters: false }
    }
  ];

  return (
    <FilterBar<SelectSoftwarePackageVersionFilterValues>
      items={filterItems}
      initialValues={{
        name: ""
      }}
    >
      {children}
    </FilterBar>
  );
};
